<ng-template #tooltip>
  <div class="d-flex flex-column">
    <span innerHTML="{{ toolTipMessage }}"></span>
  </div>
</ng-template>
<span type="button" class="ml-2" [placement]="placement" [ngbTooltip]="tooltip">
  <em class="fa fa-info-circle" aria-hidden="true"></em>
</span>
